import React from 'react';
import { PageHeader } from 'antd';
import { useGetSellersQuery } from '../../../app/api/userApiSlice';
import SellerTable from '../containers/SellerTable';

const ListSellers: React.FC = () => {
  const { data: sellers, isLoading } = useGetSellersQuery(undefined, {
    selectFromResult: ({ data, isLoading }) => {
      return {
        data: data?.filter((seller) => seller.status.id === 2 || seller.status.id === 3),
        isLoading,
      };
    },
  });

  return (
    <>
      <PageHeader className='site-page-header' title='Sellers' extra={[]} />
      <SellerTable sellers={sellers} isLoading={isLoading} />
    </>
  );
};

export default ListSellers;
